export const modalSizeOptions = {
  'XX-SMALL': 'xx-small',
  'X-SMALL': 'x-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  'X-LARGE': 'x-large',
  'XX-LARGE': 'xx-large'
}

export const modalSizeOptionsStyle = {
  [modalSizeOptions['XX-SMALL']]: {
    colStart: 5,
    colSpan: 2,
    maxHeight: '0.3'
  },
  [modalSizeOptions['X-SMALL']]: {
    colStart: 5,
    colSpan: 3,
    maxHeight: '0.4'
  },
  [modalSizeOptions.SMALL]: {
    colStart: 5,
    colSpan: 4,
    maxHeight: '0.4'
  },

  [modalSizeOptions.MEDIUM]: {
    colStart: 4,
    colSpan: 6,
    maxHeight: '0.6'
  },

  [modalSizeOptions.LARGE]: {
    colStart: 3,
    colSpan: 8,
    maxHeight: '0.75'
  },

  [modalSizeOptions['X-LARGE']]: {
    colStart: 2,
    colSpan: 10,
    maxHeight: '0.8'
  },

  [modalSizeOptions['XX-LARGE']]: {
    colStart: 1,
    colSpan: 12,
    maxHeight: '1'
  }
}
